var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import { TokenIncomingOutgoingItemComponent } from '@popup/steem/pages/app-container/home/tokens/token-delegations/token-incoming-outgoing-page/token-incoming-outgoing-item.component/token-incoming-outgoing-item.component';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FormatUtils from 'src/utils/format.utils';
const TokenIncomingOutgoingPage = ({ delegationType, tokenBalance, tokenInfo, activeAccountName, setTitleContainerProperties, }) => {
    const header = delegationType === DelegationType.INCOMING
        ? 'popup_html_total_incoming'
        : 'popup_html_total_outgoing';
    const [total, setTotal] = useState('...');
    const [delegationList, setDelegationList] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({
            title: delegationType,
            isBackButtonEnabled: true,
        });
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        let delegations;
        if (delegationType === DelegationType.INCOMING) {
            delegations = yield TokensUtils.getIncomingDelegations(tokenBalance.symbol, activeAccountName);
        }
        else {
            delegations = yield TokensUtils.getOutgoingDelegations(tokenBalance.symbol, activeAccountName);
        }
        setDelegationList(delegations);
        const balance = delegationType === DelegationType.INCOMING
            ? tokenBalance.delegationsIn
            : tokenBalance.delegationsOut;
        setTotal(FormatUtils.withCommas(balance, FormatUtils.hasMoreThanXDecimal(parseFloat(balance), 3) ? 8 : 3));
    });
    return (React.createElement("div", { "data-testid": `${Screen.TOKENS_DELEGATIONS}-page`, className: "token-incoming-outgoing-page" },
        delegationType === DelegationType.OUTGOING &&
            tokenInfo.undelegationCooldown > 0 && (React.createElement("div", { className: "cooldown-message" }, getMessage('popup_html_token_undelegation_cooldown_disclaimer', [tokenInfo.symbol, tokenInfo.undelegationCooldown.toString()]))),
        React.createElement("div", { className: "list-panel" },
            React.createElement("div", { className: "panel" },
                React.createElement("div", { className: "total" },
                    React.createElement("div", { className: "label" }, getMessage(header)),
                    React.createElement("div", { className: "value" },
                        total,
                        " ",
                        tokenBalance.symbol)),
                React.createElement("div", { className: "list" }, delegationList.map((delegation, index) => (React.createElement(TokenIncomingOutgoingItemComponent, { key: index, delegationType: delegationType, username: delegationType === DelegationType.INCOMING
                        ? delegation.from
                        : delegation.to, amount: delegation.quantity, symbol: tokenBalance.symbol }))))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccountName: state.steem.activeAccount.name,
        delegationType: state.navigation.stack[0].params
            .delegationType,
        tokenBalance: state.navigation.stack[0].params.tokenBalance,
        tokenInfo: state.navigation.stack[0].params.tokenInfo,
    };
};
const connector = connect(mapStateToProps, {
    setTitleContainerProperties,
});
export const TokenIncomingOutgoingPageComponent = connector(TokenIncomingOutgoingPage);
